export class InvestigationFormEntity {
  public id!: string;
  public name!: string;
  public description!: string;
  public investigationTypeId!: string;
  public investigationTypeName!: string;
  public status!: 'Draft' | 'Published' | 'Archived';
  public statusName!: string;
  public publishedVersionId!: string | null;
  public publishedVersionNumber!: number | null;
  public fieldCount!: number;
  public createdAt!: Date;
  public updatedAt!: Date;
}
